export enum LocalStorageKey {
  CUSTOM_MAP_CREATION_INTRO_VIEWED = 'CUSTOM_MAP_CREATION_INTRO_VIEWED',
  CFD_FILTER_STATE = 'CFD_FILTER_STATE',
  CFD_LIST_ITEMS_PER_PAGE = 'CFD_LIST_ITEMS_PER_PAGE',
  CFD_CROP_LIST_ITEMS_PER_PAGE = 'CFD_CROP_LIST_ITEMS_PER_PAGE',
  CFD_CROP_DETAILS_COLUMNS = 'CFD_CROP_DETAILS_COLUMNS',
  CFD_CROP_DETAILS_CUSTOM_TANK_MIXES = 'CFD_CROP_DETAILS_CUSTOM_TANK_MIXES',
  AUTOMATIC_BOUNDARY_DETECTION_BOTTOM_CONTROLS_GUIDANCE_VIEWED = 'AUTOMATIC_BOUNDARY_DETECTION_BOTTOM_CONTROLS_GUIDANCE_VIEWED',
  AUTOMATIC_BOUNDARY_DETECTION_SELECT_GUIDANCE_VIEWED = 'AUTOMATIC_BOUNDARY_DETECTION_SELECT_GUIDANCE_VIEWED',
  DRAW_FIELD_DRAWING_GUIDANCE_VIEWED = 'DRAW_FIELD_DRAWING_GUIDANCE_VIEWED',
  DRAW_FIELD_DRAG_GUIDANCE_VIEWED = 'DRAW_FIELD_DRAG_GUIDANCE_VIEWED',
  DRAW_FIELD_CUTTING_GUIDANCE_VIEWED = 'DRAW_FIELD_CUTTING_GUIDANCE_VIEWED',
  DRAW_FIELD_ZONE_GUIDANCE_VIEWED = 'DRAW_FIELD_ZONE_GUIDANCE_VIEWED',
  DRAW_REFERENCE_LINE_ADD_GUIDANCE_VIEWED = 'DRAW_REFERENCE_LINE_ADD_GUIDANCE_VIEWED',
  DRAW_REFERENCE_LINE_EDIT_GUIDANCE_VIEWED = 'DRAW_REFERENCE_LINE_EDIT_GUIDANCE_VIEWED',
  DRAW_REFERENCE_LINE_TRAMLINE_GUIDANCE_VIEWED = 'DRAW_REFERENCE_LINE_TRAMLINE_GUIDANCE_VIEWED',
  MAP_IMPORT_GUIDANCE_VIEWED = 'MAP_IMPORT_GUIDANCE_VIEWED',
  SOIL_SAMPLING_MANUAL_DATA_ENTRY_GUIDANCE_VIEWED = 'SOIL_SAMPLING_MANUAL_DATA_ENTRY_GUIDANCE_VIEWED',
  MAP_MERGE_GUIDANCE_VIEWED = 'MAP_MERGE_GUIDANCE_VIEWED',
  TASKS_PAGE_GUIDANCE_VIEWED = 'TASKS_PAGE_GUIDANCE_VIEWED',
  SOIL_SAMPLING_EXPORT_GUIDANCE_VIEWED = 'SOIL_SAMPLING_EXPORT_GUIDANCE_VIEWED',
  NEW_UNPROCESSED_MAPS_TOAST_VIEWED = 'NEW_UNPROCESSED_MAPS_TOAST_VIEWED',
  UPDATE_PAYMENT_DETAILS_TOAST_VIEWED = 'UPDATE_PAYMENT_DETAILS_TOAST_VIEWED',
  OBSERVATION_INTRO_MODAL_VIEWED = 'OBSERVATION_INTRO_MODAL_VIEWED',
  WHATS_NEW_MODAL_DISPLAYED_ON = 'WHATS_NEW_MODAL_DISPLAYED_ON',
  ONBOARDING_GUIDANCE_STEP1_SHOWN = 'ONBOARDING_GUIDANCE_STEP1_SHOWN',
  ONBOARDING_GUIDANCE_STEP2_SHOWN = 'ONBOARDING_GUIDANCE_STEP2_SHOWN',
  ONBOARDING_SMART_SPRAYER = 'ONBOARDING_SMART_SPRAYER',
  ONESOIL_GUIDANCE_VIEWED = 'ONESOIL_GUIDANCE_VIEWED',
  DRAW_REFERENCE_POINT_GUIDANCE_VIEWED = 'DRAW_REFERENCE_POINT_GUIDANCE_VIEWED',
  URL_REDIRECT_AFTER_LOGIN = 'URL_REDIRECT_AFTER_LOGIN',
  WIUZ_UPDATE_MODAL_INFO = 'WIUZ_UPDATE_MODAL_INFO',
  WIUZ_DETAILS_SCREEN_VISIBLE = 'WIUZ_DETAILS_SCREEN_VISIBLE',
  SMAG_UPDATE_MODAL_INFO = 'SMAG_UPDATE_MODAL_INFO',
  SMAG_DETAILS_SCREEN_VISIBLE = 'SMAG_DETAILS_SCREEN_VISIBLE',
  CROP_PROTECTION_TASK_DOSAGE_INFO = 'CROP_PROTECTION_TASK_DOSAGE_INFO',
  COOKIE_BANNER_CONSENT = 'COOKIE_BANNER_CONSENT',
  WEATHER_ISSUE_DISPLAYED = 'WEATHER_ISSUE_DISPLAYED',
  NUTRITION_PROGRAM_GUIDANCE = 'NUTRITION_PROGRAM_GUIDANCE',
  NUTRITION_OPTIMAL_CALCULATION_MODAL_VIEWED = 'NUTRITION_OPTIMAL_CALCULATION_MODAL_VIEWED',
  NUTRITION_COMPLIANT_BOUNDARIES_MODAL_VIEWED = 'NUTRITION_COMPLIANT_BOUNDARIES_MODAL_VIEWED',
  NUTRITION_N_DEMAND_INTRO_MODAL_VIEWED = 'NUTRITION_N_DEMAND_INTRO_MODAL_VIEWED',
  NUTRITION_N_DEMAND_SAVED_MODAL_VIEWED = 'NUTRITION_N_DEMAND_SAVED_MODAL_VIEWED',
  NUTRITION_PLANNING_MAP_CREATION_INTRO_MODAL_VIEWED = 'NUTRITION_PLANNING_MAP_CREATION_INTRO_MODAL_VIEWED',
  NUTRITION_PLANNING_MAP_CREATION_GUIDANCE_SHOWN = 'NUTRITION_PLANNING_MAP_CREATION_GUIDANCE_SHOWN',
  FDL_MAGNITUDE_UNIT = 'FDL_MAGNITUDE_UNIT',
  NOTES_PAGE_INTRO_MODAL_SHOWN = 'NOTES_PAGE_INTRO_MODAL_SHOWN',
  NOTES_PAGE_GUIDANCE_SHOWN = 'NOTES_PAGE_GUIDANCE_SHOWN',
  NOTES_PAGE_FILTERS_GUIDANCE_SHOWN = 'NOTES_PAGE_FILTERS_GUIDANCE_SHOWN',
  NOTES_PAGE_FIELD_FILTER_GUIDANCE_SHOWN = 'NOTES_PAGE_FIELD_FILTER_GUIDANCE_SHOWN',
  NOTES_PAGE_CREATION_GUIDANCE_SHOWN = 'NOTES_PAGE_CREATION_GUIDANCE_SHOWN',
  DRONE_IMAGERY_UPLOAD_INTRO_MODAL_SHOWN = 'DRONE_IMAGERY_UPLOAD_INTRO_MODAL_SHOWN',
  DRONE_MAP_CUSTOMIZATION_GUIDANCE_SHOWN = 'DRONE_MAP_CUSTOMIZATION_GUIDANCE_SHOWN',
  SMART_TRIALS_LAST_INPUTS = 'SMART_TRIALS_LAST_INPUTS',
  SMART_TRIALS_LAST_INPUTS_PER_FIELD = 'SMART_TRIALS_LAST_INPUTS_PER_FIELD',
  SMART_TRIALS_STEP_1_SHOWN = 'SMART_TRIALS_STEP_1_SHOWN',
  SMART_TRIALS_STEP_2_SHOWN = 'SMART_TRIALS_STEP_2_SHOWN',
  SMART_TRIALS_STEP_3_SHOWN = 'SMART_TRIALS_STEP_3_SHOWN',
  DRAWING_TOOLS_VIEW_OPTIONS = 'DRAWING_TOOLS_VIEW_OPTIONS',
  MAP_ZONE_SELECTION_STEP_1_SHOWN = 'MAP_ZONE_SELECTION_STEP_1_SHOWN',
  MAP_ZONE_SELECTION_STEP_2_SHOWN = 'MAP_ZONE_SELECTION_STEP_2_SHOWN',
  DRAW_FIELD_ZONE_SHAPE_DRAWN_SHOWN = 'DRAW_FIELD_ZONE_SHAPE_DRAWN_SHOWN',
  DRAW_FIELD_ZONE_EDIT_SHAPE_SHOWN = 'DRAW_FIELD_ZONE_EDIT_SHAPE_SHOWN',
  MAP_SELECTION_INTRO_SHOWN = 'MAP_SELECTION_INTRO_SHOWN',
  PREFECTURE_SELECTION_MODAL_SHOWN = 'PREFECTURE_SELECTION_MODAL_SHOWN',
  SEED_VARIETY_RECOMMENDATION_WARNING_SHOWN = 'SEED_VARIETY_RECOMMENDATION_WARNING_SHOWN',
  SEED_VARIETY_RECOMMENDATION_UPDATE_WARNING_SHOWN = 'SEED_VARIETY_RECOMMENDATION_UPDATE_WARNING_SHOWN',
  LAST_SELECTED_BASE_MAP_LAYER = 'LAST_SELECTED_BASE_MAP_LAYER',
  BUSINESS_LINES_OVERVIEW_FILTERS = 'BUSINESS_LINES_OVERVIEW_FILTERS',
  BUSINESS_LINES_REQUESTS_FILTERS = 'BUSINESS_LINES_REQUESTS_FILTERS',
  BUSINESS_OVERVIEW_STATES = 'BUSINESS_OVERVIEW_STATES',
  BUSINESS_OVERVIEW_LAST_SELECTED_FARM_ASSIGN = 'BUSINESS_OVERVIEW_LAST_SELECTED_FARM_ASSIGN',
  REDIRECT_URL_AFTER_PAYMENT_COMPLETE = 'REDIRECT_URL_AFTER_PAYMENT_COMPLETE',
  REDIRECT_LOCALE_AFTER_PAYMENT_COMPLETE = 'REDIRECT_LOCALE_AFTER_PAYMENT_COMPLETE',
  ORGANISATION_MEMBERS_LIST_FILTERS = 'ORGANISATION_MEMBERS_LIST_FILTERS',
  ANALYTICS_LIBRARY_ITEMS_PER_PAGE = 'ANALYTICS_LIBRARY_ITEMS_PER_PAGE',
  ANALYTICS_CLIPBOARD_COLLECTION = 'ANALYTICS_CLIPBOARD_COLLECTION',
  ANALYTICS_SWITCH_OLD_ENABLED = 'ANALYTICS_SWITCH_OLD_ENABLED',
  OSS_DASHBOARD_ITEMS_PER_PAGE = 'OSS_DASHBOARD_ITEMS_PER_PAGE',
  STAGING_PANEL_FORCED_ENABLED = 'STAGING_PANEL_FORCED_ENABLED',
  IS_XARVIO_HF_LOGOUT_REQUIRED = 'IS_XARVIO_HF_LOGOUT_REQUIRED',
  IS_XARVIO_HF = 'IS_XARVIO_HF',
  IS_XARVIO_HF_REGISTRATION_FLOW = 'IS_XARVIO_HF_REGISTRATION_FLOW',
  BARILLA_INITIAL_ONBOARDING_IN_PROGRESS = 'BARILLA_INITIAL_ONBOARDING_IN_PROGRESS',
  PERONI_INITIAL_ONBOARDING_IN_PROGRESS = 'PERONI_INITIAL_ONBOARDING_IN_PROGRESS',
  GRAPES_INITIAL_ONBOARDING_IN_PROGRESS = 'GRAPES_INITIAL_ONBOARDING_IN_PROGRESS',
  NUTRITION_ADVISOR_ALL_NUTRIENTS_TAB_GUIDANCE_SHOWN = 'NUTRITION_ADVISOR_ALL_NUTRIENTS_TAB_GUIDANCE_SHOWN',
  NUTRITION_ADVISOR_SINGLE_NUTRIENT_TAB_GUIDANCE_SHOWN = 'NUTRITION_ADVISOR_SINGLE_NUTRIENT_TAB_GUIDANCE_SHOWN',
  NUTRITION_ADVISOR_NUTRITION_PROGRAMS_TAB_GUIDANCE_SHOWN = 'NUTRITION_ADVISOR_NUTRITION_PROGRAMS_TAB_GUIDANCE_SHOWN',
  NUTRITION_PRECIFIELD_GUIDANCE_SHOWN = 'NUTRITION_PRECIFIELD_GUIDANCE_SHOWN',
  NUTRITION_PRECIFIELD_DATA_PROVIDED_GUIDANCE_SHOWN = 'NUTRITION_PRECIFIELD_DATA_PROVIDED_GUIDANCE_SHOWN',
  NEW_HISTORY_PAGE_GUIDANCE_SHOWN = 'NEW_HISTORY_PAGE_GUIDANCE_SHOWN',
  FIELD_VARIABILITY_INDEX_GUIDANCE_SHOWN = 'FIELD_VARIABILITY_INDEX_GUIDANCE_SHOWN',
  SOIL_SAMPLING_EXPORT_MODAL_MEASUREMENTS = 'SOIL_SAMPLING_EXPORT_MODAL_MEASUREMENTS',
  CROP_ASSIGNMENT_ACCURATE_DATA_GUIDANCE_SHOWN = 'CROP_ASSIGNMENT_ACCURATE_DATA_GUIDANCE_SHOWN',
  CROP_PROTECTION_FIELDS_VIEW_AUTO_DOSAGE_DISTRIBUTION_GUIDANCE_VIEWED = 'CROP_PROTECTION_FIELDS_VIEW_AUTO_DOSAGE_DISTRIBUTION_GUIDANCE_VIEWED',
  CROP_PROTECTION_FIELDS_VIEW_MANUAL_DOSAGE_DISTRIBUTION_GUIDANCE_VIEWED = 'CROP_PROTECTION_FIELDS_VIEW_MANUAL_DOSAGE_DISTRIBUTION_GUIDANCE_VIEWED',
  FIELD_TRIALS_PAGE_FILTERS = 'FIELD_TRIALS_PAGE_FILTERS',
  AG_DASHBOARD_SELECTED_DATAPOINTS = 'AG_DASHBOARD_SELECTED_DATAPOINTS',
  AG_COTEGRA_SELECTED_DATAPOINTS = 'AG_COTEGRA_SELECTED_DATAPOINTS',
  EXPERT_VIEW_HF_COORDINATOR_FORECAST_ACCURACY_GUIDANCE_SHOWN = 'EXPERT_VIEW_HF_COORDINATOR_FORECAST_ACCURACY_GUIDANCE_SHOWN',
  CARBON_FARMING_CI_SCORE_UNITS_FLIPPED = 'CARBON_FARMING_CI_SCORE_UNITS_FLIPPED',
}

export enum DeprecatedLocalStorageKey {
  WEED_EMERGENCE_GUIDANCE_SHOWN = 'WEED_EMERGENCE_GUIDANCE_SHOWN',
}

const set = (key: LocalStorageKey, value: unknown) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

const get = (key: LocalStorageKey) => {
  const val = window.localStorage.getItem(key);

  return val ? JSON.parse(val) : val;
};

const remove = (key: LocalStorageKey) => {
  window.localStorage.removeItem(key);
};

export const LocalStorageUtil = {
  set,
  get,
  remove,
};
